export const Input = {
  variants: {
    outline: {
      field: {
        _hover: {
          backgroundColor: 'hover.gray',
        },
        _focus: {
          backgroundColor: 'white',
        },
      },
    },
  },
  defaultProps: {
    focusBorderColor: 'upgrade.blue.500',
  },
  baseStyle: {
    field: {
      _placeholder: { color: 'font.300' },
    },
  },
};

export const NumberInput = {
  variants: {
    outline: {
      field: {
        _hover: {
          backgroundColor: 'hover.gray',
        },
        _focus: {
          backgroundColor: 'white',
        },
        _placeholder: { color: 'font.300' },
      },
    },
  },
  defaultProps: {
    focusBorderColor: 'upgrade.blue.500',
  },
  baseStyle: {
    field: {
      _placeholder: { color: 'font.300' },
    },
  },
};
